import { useState } from "react";



export function useBlcHighlights() {
    
    const [newsIndex, setNewsIndex] = useState(0);

    return[newsIndex,setNewsIndex];
}